import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_ENTERPRISES_START, POST_ENTERPRISES_ERROR, POST_ENTERPRISES_START, POST_ENTERPRISES_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/enterprises/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_ENTERPRISES_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_ENTERPRISES_ERROR, error });
  } finally {
    yield put({ type: GET_ENTERPRISES_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* post_enterprises() {
  yield takeLatest(POST_ENTERPRISES_START, create);
}